webpackJsonp([135624512556479],{

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Anchor = __webpack_require__(41);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _CodeBlock = __webpack_require__(21);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _DocPage = __webpack_require__(20);
	
	var _DocPage2 = _interopRequireDefault(_DocPage);
	
	var _ApiDocs = __webpack_require__(61);
	
	var _ApiDocs2 = _interopRequireDefault(_ApiDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _DocPage2.default,
	    { title: 'ModifiersUtils API' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Set of functions used internally to work with modifiers.'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      'import { ModifiersUtils } from "react-day-picker";'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _ApiDocs2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Functions'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'dayMatchesModifier' }),
	        'dayMatchesModifier ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day: Date, modifier: Any) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day'
	        ),
	        ' date matches',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'modifier'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'getModifiersForDay' }),
	        'getModifiersForDay ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day: Date, modifiers: Object) \u21D2 Array'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return the modifiers matching ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day'
	        ),
	        ' for the given',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'modifiers'
	        ),
	        '.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-api-modifiers-utils-js-37d05e2aeb2b5460e99e.js